import { Application } from 't3js';
import ajax from '@buzzfeed/buzzblocks/js/services/ajax';

/**
 * Handles interaction with the buzzfeed login endpoint to provide
 * a more seamless authentication experience
 */
class BuzzFeedLogin {
  /**
   * @constructor
   * @param context
   */
  constructor(context) {
    this._element = context.getElement();
    this._fieldset = this._element.querySelector('.fieldset');
    this._feedbackLabel = this._element.querySelector('.form-feedback');
    this._usernameField = this._element.querySelector('[name=username]');
    this._passwordField = this._element.querySelector('[name=password]');
    this._csrfField = this._element.querySelector('[name="gorilla.csrf.Token"]');
    this._onSubmitLock = false;
  }

  /**
   * Sets a text error on the form
   * @param errorMsg (string) the message to display
   */
  setError(errorMsg) {
    this._setError();
    this._feedbackLabel.innerText = errorMsg;
  }

  /**
   * Sets an HTML error on the form
   * @param errorMsg (string) the HTML template of the message to display
   */
  setHTMLError(errorMsg) {
    this._setError();
    this._feedbackLabel.innerHTML = errorMsg;
  }

  /**
   * Shows the error on the form
   */
  _setError() {
    this.resetFeedback();
    this._feedbackLabel.classList.remove('js-hidden');
    this._fieldset.classList.add('form-fieldset--error');
  }

  /**
   * Sets an success message on the form
   * @param successMsg (string) the message to display
   */
  setSuccess(successMsg) {
    this.resetFeedback();
    this._feedbackLabel.innerText = successMsg;
    this._feedbackLabel.classList.remove('js-hidden');
    this._fieldset.classList.add('form-fieldset--success');
  }

  /**
   * Set Loading
   */
  setLoading() {
    this.resetFeedback();
    this._fieldset.classList.add('form-fieldset--loading');
  }

  /**
   * Set Loaded
   */
  setLoaded() {
    this.resetFeedback();
    this._fieldset.classList.remove('form-fieldset--loading');
  }

  /**
   * Removes error/success messages from the form
   */
  resetFeedback() {
    this._feedbackLabel.innerText = '';
    this._feedbackLabel.classList.add('js-hidden');
    this._fieldset.classList.remove('form-fieldset--error');
    this._fieldset.classList.remove('form-fieldset--success');
  }

  /**
   * Listens to all module click events, if it is a click on the
   * button login then trigger onSubmit
   */
  onclick(e, elem, elemType) {
    if (elemType === 'login') {
      e.preventDefault();
      this.onSubmit();
    }
    return false;
  }

  /**
   * Triggered when the form button is clicked via onclick
   * Handles the XHR
   */
  onSubmit() {
    if (this._onSubmitLock) {
      return Promise.resolve();
    }
    this._onSubmitLock = true;
    this.setLoading();

    const username = encodeURIComponent(this._usernameField.value);
    const password = encodeURIComponent(this._passwordField.value);
    const csrf = encodeURIComponent(this._csrfField.value);
    const buzzfeedLoginEndpoint = '/auth/login/buzzfeed';

    return ajax.post(buzzfeedLoginEndpoint, {
      type: 'json',
      data: {
        'gorilla.csrf.Token': csrf,
        username,
        password,
      },
    })
    .then(response => {
      this.setLoaded();
      this._onSubmitLock = false;
      if (response.error) {
        if (response.html) {
          this.setHTMLError(response.html);
        } else {
          this.setError(response.error);
        }
        return;
      }
      if (response.success) {
        this.setSuccess(response.success);
        window.location = window.redirectUri || '/';
        return;
      }
    })
    .catch(() => {
      this._onSubmitLock = false;
      this.setLoaded();
      this.setError('unexpected error occurred');
    });
  };
}

Application.addModule('buzzfeed-login', (context) => {
  return new BuzzFeedLogin(context);
});



// WEBPACK FOOTER //
// /app/static/js/modules/buzzfeed-login.js